import { action } from 'satcheljs';
export default action('RESET_OPTIONS_SEARCH', function (successfulSearch) { return ({
    successfulSearch: successfulSearch,
}); });
//# sourceMappingURL=resetSearch.js.map